// Also used as a string literal in public/embed.js — keep in sync when changing
export const EMBED_CART_UPDATE = 'safeticket-cart-update';
export const EMBED_CLOSE_DRAWER = 'safeticket-close-drawer';
export const EMBED_RESTART_DRAWER = 'safeticket-restart-drawer';
